import React, { useState, useEffect } from 'react';
import BulletinListTable from '../commission_payment/CommissionPaymentTable';
import { getCommission_bulletins, clearCommission_bulletins } from '../../flux/actions/commissionbulletinActions';
import { Container, Row, Col, Label } from 'reactstrap';

import { connect } from 'react-redux';
import { IBulletinListContainer, IBulletinListContainerReduxProps } from '../../types/interfaces';
import Loading from '../../components/Loading';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus, faFileInvoiceDollar, faListAlt } from '@fortawesome/free-solid-svg-icons'

import { useBeforeunload } from 'react-beforeunload';

import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";
import Select from 'react-select';
import { PRIVILEGE } from '../../types/privileges';

const BulletinListContainerComponent = ({ 
  getCommission_bulletins,
  clearCommission_bulletins,
  commission_bulletin,
  user,
  auth
 }: IBulletinListContainer) => {

  const { commission_bulletins, loading } = commission_bulletin;
  const { users, loading: loadingU } = user;
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) ? [{id: "ALL", LOGIN: "Tous les commerciaux"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));
  const [tableData, setTableData] = useState(commission_bulletins);
  const [selectedRows, setSelectedRows] = useState(Array());
  const [clearFilters, setClearFilters] = useState(false);

  const [selectedUser, setSelectedUser] = useState<any>('');

  useBeforeunload((e) => {
    if(selectedRows.length)
      e.preventDefault();
  });

  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }

  useEffect(() => {
    if(auth?.user?.id !== undefined && selectedUser === '')
      setSelectedUser(userOptions.find(e => e.value === (auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) ? "ALL" : auth.user.id))?.user || '')
  }, [auth?.user?.id]);

  const clearInputs = () => {
    setSelectedUser('');
  }

  useEffect(() => {
    clearCommission_bulletins();
    if(selectedUser)
    getCommission_bulletins(selectedUser["id"]);
  }, [getCommission_bulletins, selectedUser]);

  useEffect(() => {
    return () => clearCommission_bulletins()
  }, []);

  useEffect(() => {
    setTableData(commission_bulletins.map(e => {
      const left = (e.commission_bulletin_lines?.reduce((n, t) => n + (t.commission || 0) + (t.bonus_malus || 0), 0) || 0) + e.bonus_malus - e.paid
      return e.left = left, e.left_table = left, e;
    }));
  }, [commission_bulletins]);

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col sm="12" md="6"><h4 className="title"><FontAwesomeIcon icon={faListAlt} />&nbsp;&nbsp;Bulletins des Commissions</h4></Col>
          <Col sm="12" md="2" className="listPageFilterTitle">
            <Label for="user">Commercial : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
            <Select
              name="user"
              className="reactselect"
              classNamePrefix="react-select"
              value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
              onChange={handleUserChange}
              placeholder={'Chercher par nom...'}
              isClearable={false}
              isLoading={loadingU}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              // labelKey='LOGIN'
              // valueKey='countryCode'
              options={userOptions}
            />
          </Col>
        </Row>
      </Container>
      {loading ? <Loading topSpace /> : <BulletinListTable linesData={tableData} setTableData={setTableData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} clearFilters={clearFilters} setClearFilters={setClearFilters} showComColumn={selectedUser?.id === "ALL"} />}
    </>
  );
};

const mapStateToProps = (state: IBulletinListContainerReduxProps) => ({
  commission_bulletin: state.commission_bulletin,
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getCommission_bulletins, clearCommission_bulletins })(BulletinListContainerComponent);
